/*
  COTANTIN：分割商品のページ（2026-10-31 代表決定の下絵「分割商品 X3」）。
  1. 色の列（snippets/cotantin-pdp-colors）
     - 押すと、隠してある Prestige の選択肢（variant-picker）の同じ色のラベルを押す → Prestige が描き直す
     - 描き直しで列ごと差し替わるので、横の位置を覚えておいて戻す
     - スマホだけ：右端の「›」で残りの色まで送る／いちばん右まで行ったら「›」とグラデーションを消す／下の線で位置を出す
     - スマホだけ：ページを開いて列が画面に入ったら、一度だけ左へ約 60px 動いて戻る（さわったら止める・視差効果を減らす設定では動かさない）
  2. 配送オプションのトグル（snippets/cotantin-pdp-ship）
     - 押すと、隠してある Prestige の選択肢の「受注生産」「即納」を押す
     - 在庫が無いときは吹き出しを 2.5 秒。即納のまま在庫の無い色に替えたら受注生産に戻す
     - 「?」は assets/cotantin-ship.js の説明（window.ctOpenShipSheet）を開く
  3. 写真の左下の色の名前（写真の alt に色の名前が無い商品＝Secrète）
     - 色の列の data-chip-name / data-chip-ja を、写真の一覧の上に重ねる（snippets/cotantin-gallery-band がある商品では出さない）
  4. 商品名の横の「対応バッグは？」（data-ct-fit-open）で、対応バッグの説明（snippets/cotantin-sub-fit-sheet）を開く
*/
(function () {
  if (window.__ctPdpX3) return;
  window.__ctPdpX3 = true;

  // Prestige は選び直すたびに liquid ブロックを差し替える。ブロックの中に置いた <link> も一度外れて入り直すので、
  // そのあいだ CSS が外れる（購入欄がちらつき、色の列を崩れた幅で測ってしまう）。最初に head へ写しておく
  ['cotantin-pdp-x3.css', 'cotantin-ship.css'].forEach(function (name) {
    var link = document.querySelector('link[rel="stylesheet"][href*="/' + name + '"]');
    if (link && !document.head.contains(link)) document.head.appendChild(link.cloneNode());
  });

  var MOBILE = window.matchMedia('(max-width: 999px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var memo = {};       // 商品ID → 色の列の横の位置
  var nudged = false;  // 開いたときの動きは1回だけ

  // 隠してある Prestige の選択肢から、指定の位置・値のラベルを探して押す
  function pickPrestige(from, position, value) {
    var root = from.closest('.product-info') || document;
    var inputs = root.querySelectorAll('variant-picker input[data-option-position="' + position + '"]');
    for (var i = 0; i < inputs.length; i++) {
      var label = root.querySelector('label[for="' + inputs[i].id + '"]');
      var text = label ? label.textContent.trim() : '';
      if (text === value) {
        if (!inputs[i].checked) (label || inputs[i]).click();
        return true;
      }
    }
    return false;
  }

  // ---------- 1. 色の列 ----------
  function easeInOut(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

  function initColors(el) {
    if (el.hasAttribute('data-ct-ready')) return;
    el.setAttribute('data-ct-ready', '');
    var strip = el.querySelector('[data-ct-colors-strip]');
    var more = el.querySelector('[data-ct-colors-more]');
    var thumb = el.querySelector('[data-ct-colors-thumb]');
    var pid = el.getAttribute('data-product-id');
    if (!strip) return;
    var anim = 0;

    function update() {
      var max = strip.scrollWidth - strip.clientWidth;
      var x = strip.scrollLeft;
      el.classList.toggle('is-end', max <= 2 || x >= max - 2);
      el.classList.toggle('is-scrolled', x > 2);
      if (thumb && strip.scrollWidth > 0) {
        var ratio = Math.min(1, strip.clientWidth / strip.scrollWidth);
        thumb.style.width = (ratio * 100) + '%';
        thumb.style.transform = 'translateX(' + (max > 0 ? (x / max) * ((1 - ratio) / ratio) * 100 : 0) + '%)';
      }
    }

    // Prestige の描き直しで差し込まれた直後は、まだ幅が決まっていないことがある（測ると 0 や全幅になる）。
    // 幅が決まってから位置を戻し、測り直す（ResizeObserver は最初の1回と、幅が変わるたびに呼ばれる）
    var placed = false;
    function place() {
      if (!strip.clientWidth) return;
      if (!placed) {
        placed = true;
        if (memo[pid] != null) {
          strip.scrollLeft = memo[pid];
        } else {
          // URL で指定された色が列の外にあるときは、見えるところまで送っておく
          var sel = strip.querySelector('[aria-checked="true"]');
          if (sel && sel.offsetLeft + sel.offsetWidth > strip.clientWidth - 48) {
            strip.scrollLeft = sel.offsetLeft - 16;
          }
        }
      }
      update();
    }
    place();
    if ('ResizeObserver' in window) new ResizeObserver(place).observe(strip);
    else window.addEventListener('resize', place, { passive: true });

    strip.addEventListener('scroll', function () { if (placed) memo[pid] = strip.scrollLeft; update(); }, { passive: true });

    function stop() { if (anim) { cancelAnimationFrame(anim); anim = 0; } nudged = true; }
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { strip.addEventListener(ev, stop, { passive: true }); });

    if (more) {
      more.addEventListener('click', function () {
        stop();
        strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: reduce.matches ? 'auto' : 'smooth' });
      });
    }

    strip.addEventListener('click', function (event) {
      var sw = event.target.closest('[data-value]');
      if (!sw) return;
      memo[pid] = strip.scrollLeft;
      strip.querySelectorAll('[data-value]').forEach(function (b) { b.setAttribute('aria-checked', b === sw ? 'true' : 'false'); });
      // 写真の名前は先に替えておく（描き直しが届いたら和名も入る）
      el.setAttribute('data-chip-name', sw.getAttribute('data-value'));
      el.setAttribute('data-chip-ja', '');
      syncChip(el);
      pickPrestige(el, 1, sw.getAttribute('data-value'));
    });

    // 開いたときの動き（スマホだけ・1回だけ）。1列にそのまま並べる形（fit）では動かさない
    if (el.classList.contains('ct-colors--fit')) return;
    if (!nudged && MOBILE.matches && !reduce.matches && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || nudged) return;
          io.disconnect();
          setTimeout(function () {
            if (nudged || strip.scrollWidth - strip.clientWidth < 8) return;
            nudged = true;
            var base = strip.scrollLeft, dist = 60, out = 520, hold = 140, back = 560, start = null;
            function step(ts) {
              if (start === null) start = ts;
              var t = ts - start;
              var x;
              if (t < out) x = base + dist * easeInOut(t / out);
              else if (t < out + hold) x = base + dist;
              else if (t < out + hold + back) x = base + dist * (1 - easeInOut((t - out - hold) / back));
              else { strip.scrollLeft = base; anim = 0; return; }
              strip.scrollLeft = x;
              anim = requestAnimationFrame(step);
            }
            anim = requestAnimationFrame(step);
          }, 600);
        });
      }, { threshold: 0.6 });
      io.observe(el);
    }
  }

  // ---------- 3. 写真の左下の色の名前 ----------
  function syncChip(el) {
    var product = el.closest('.product') || document;
    var list = product.querySelector('.product-gallery__image-list');
    if (!list || product.querySelector('.ct-gband')) return;
    var chip = list.querySelector(':scope > .ct-photo-chip');
    var name = el.getAttribute('data-chip-name') || '';
    if (!name) { if (chip) chip.hidden = true; return; }
    if (!chip) {
      chip = document.createElement('p');
      chip.className = 'ct-photo-chip';
      chip.setAttribute('aria-hidden', 'true');
      chip.innerHTML = '<span class="ct-photo-chip__en"></span><span class="ct-photo-chip__jp"></span>';
      list.appendChild(chip);
    }
    chip.hidden = false;
    var ja = el.getAttribute('data-chip-ja') || '';
    chip.firstChild.textContent = name;
    chip.lastChild.textContent = ja;
    chip.lastChild.hidden = !ja;
  }

  // ---------- 2. 配送オプション ----------
  function showTip(toggle) {
    var tip = toggle && toggle.querySelector('[data-ship-tip]');
    if (!tip) return;
    tip.hidden = false;
    clearTimeout(tip.__t);
    tip.__t = setTimeout(function () { tip.hidden = true; }, 2500);
  }

  function initShip(box) {
    if (box.hasAttribute('data-ct-ready')) return;
    box.setAttribute('data-ct-ready', '');
    // 即納のまま在庫の無い色に替えたときは、受注生産に戻す
    if (box.getAttribute('data-on') === 'true' && box.getAttribute('data-avail') !== 'true') {
      pickPrestige(box, box.getAttribute('data-pos'), box.getAttribute('data-made'));
    }
  }

  document.addEventListener('click', function (event) {
    var fit = event.target.closest('[data-ct-fit-open]');
    if (fit) {
      event.preventDefault();
      if (window.ctOpenShipSheet) window.ctOpenShipSheet(fit, null, 'fit');
      return;
    }
    var box = event.target.closest('[data-ct-ship-pdp]');
    if (!box) return;
    var help = event.target.closest('[data-ship-help]');
    var on = box.getAttribute('data-on') === 'true';
    if (help) {
      if (window.ctOpenShipSheet) window.ctOpenShipSheet(help, on ? 'express' : 'made');
      return;
    }
    var sw = event.target.closest('[data-ship-switch]');
    if (!sw) return;
    if (box.getAttribute('data-avail') !== 'true') { showTip(sw.closest('[data-ct-ship]')); return; }
    // 押した感触を先に出す（描き直しが届くまで）
    sw.setAttribute('aria-checked', on ? 'false' : 'true');
    pickPrestige(box, box.getAttribute('data-pos'), box.getAttribute(on ? 'data-made' : 'data-express'));
  });

  function scan() {
    document.querySelectorAll('[data-ct-colors]:not([data-ct-ready])').forEach(function (el) { initColors(el); syncChip(el); });
    document.querySelectorAll('[data-ct-ship-pdp]:not([data-ct-ready])').forEach(initShip);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  // Prestige は選び直すたびに liquid ブロックを差し替える（allow-partial-rerender）。新しい要素が来たら付け直す
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
